import { Locale } from 'next-intl'

export const countWords = (text: string) => {
  const chineseChars = (text.match(/[\u4e00-\u9fff]/g) || []).length
  const japaneseKana = (text.match(/[\u3040-\u309f\u30a0-\u30ff]/g) || []).length
  const englishWords = (text.match(/[A-Za-z]+(?:'[A-Za-z]+)?/g) || []).length

  return chineseChars + japaneseKana + englishWords
}

export const getWordCountThreshold = (locale: Locale, isDesktop: boolean) => {
  const isCJK = ['zh-TW', 'ja-JP'].includes(locale)
  if (isDesktop) {
    return isCJK ? 100 : 25
  }
  return isCJK ? 60 : 15
}
